import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable @typescript-eslint/no-shadow */
import { toast } from '@livable/saas-react-components';
import { getParent, types } from 'mobx-state-tree';
import { track } from 'src/configs/amplitude';
import { httpClientCancelTokenStatic, isHttpClientCancel } from 'src/core/services/api/httpClient';
import { generateServerResponseErrorText } from '../serverErrorValidation';
import { parseJwt } from 'src/core/services/jwt';
import { AUTH_TOKEN_KEYS } from 'src/constants/authToken';
// import { TAsyncActionOptions } from 'src/core/services/api/utils';

const asyncModel = types.model('async', {
  inProgress: false,
  inProgressUnicIds: types.maybeNull(types.array(types.string)),
  inProgressRetry: false,
  error: types.optional(types.frozen(), null),
  hasEverBeenRun: false,
  throwable: false
}).views(store => ({
  get errorMessage() {
    if (store.error && store.error.message) {
      return store.error.message;
    }
    return null;
  },
  get isError() {
    return !!store.error;
  },
  get canBeRun() {
    return !store.error && !store.inProgress;
  },
  get inProgressAgain() {
    return store.inProgress && store.hasEverBeenRun;
  }
})).actions(store => ({
  start() {
    let retry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (retry) {
      store.inProgressRetry = true;
    } else {
      store.inProgress = true;
    }
    store.error = null;
  },
  success() {
    if (!store.hasEverBeenRun) {
      store.hasEverBeenRun = true;
    }
    if (store.inProgressRetry) {
      store.inProgressRetry = false;
    } else {
      store.inProgress = false;
    }
  },
  failed(err) {
    var _response$request$res, _response$request, _response$request$res2, _response$request2, _response$request$res3, _response$request3, _response$status2, _response$headers$cor, _response$data$Error$2, _response$data11;
    if (!store.hasEverBeenRun) {
      store.hasEverBeenRun = true;
    }
    if (store.inProgressRetry) {
      store.inProgressRetry = false;
    } else {
      store.inProgress = false;
    }
    const response = err === null || err === void 0 ? void 0 : err.response;
    if (response) {
      var _response$data$isSucc, _response$data, _response$status, _response$statusText, _response$data$meta, _response$data2, _ref, _response$data$Error$, _response$data3, _response$data4, _response$data5, _response$data$Error, _response$data6, _response$data7, _response$data8, _response$data$Error2, _response$data9, _response$data0, _response$data$Error3, _response$data1, _response$data10;
      store.error = {
        isSuccessful: (_response$data$isSucc = response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.isSuccessful) !== null && _response$data$isSucc !== void 0 ? _response$data$isSucc : null,
        status: (_response$status = response === null || response === void 0 ? void 0 : response.status) !== null && _response$status !== void 0 ? _response$status : null,
        statusText: (_response$statusText = response === null || response === void 0 ? void 0 : response.statusText) !== null && _response$statusText !== void 0 ? _response$statusText : null,
        meta: (_response$data$meta = response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.meta) !== null && _response$data$meta !== void 0 ? _response$data$meta : null,
        errorCode: (_ref = (_response$data$Error$ = response === null || response === void 0 || (_response$data3 = response.data) === null || _response$data3 === void 0 || (_response$data3 = _response$data3.Error) === null || _response$data3 === void 0 ? void 0 : _response$data3.ErrorCode) !== null && _response$data$Error$ !== void 0 ? _response$data$Error$ : response === null || response === void 0 || (_response$data4 = response.data) === null || _response$data4 === void 0 || (_response$data4 = _response$data4.error) === null || _response$data4 === void 0 ? void 0 : _response$data4.errorCode) !== null && _ref !== void 0 ? _ref : null,
        errorResp: generateServerResponseErrorText(response === null || response === void 0 || (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.errors, (_response$data$Error = response === null || response === void 0 || (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.Error) !== null && _response$data$Error !== void 0 ? _response$data$Error : response === null || response === void 0 || (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.error)
      };
      toast('error', generateServerResponseErrorText(response === null || response === void 0 || (_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : _response$data8.errors, (_response$data$Error2 = response === null || response === void 0 || (_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.Error) !== null && _response$data$Error2 !== void 0 ? _response$data$Error2 : response === null || response === void 0 || (_response$data0 = response.data) === null || _response$data0 === void 0 ? void 0 : _response$data0.error, (response === null || response === void 0 ? void 0 : response.status) === 400 ? null : response === null || response === void 0 ? void 0 : response.headers['correlation-id']), (response === null || response === void 0 ? void 0 : response.status) === 400 ? undefined : {
        autoClose: false
      });
      track('api-error', {
        body: (_response$data$Error3 = response === null || response === void 0 || (_response$data1 = response.data) === null || _response$data1 === void 0 ? void 0 : _response$data1.Error) !== null && _response$data$Error3 !== void 0 ? _response$data$Error3 : response === null || response === void 0 || (_response$data10 = response.data) === null || _response$data10 === void 0 ? void 0 : _response$data10.error
      });
    } else {
      const e = new Error(err);
      store.error = err;
      toast('error', {
        title: 'Error',
        body: [e.message]
      });
      track('api-error', {
        body: e.message
      });
    }
    if (window.location.hostname === 'localhost') return;
    let accId = null;
    if (!!localStorage.getItem(AUTH_TOKEN_KEYS.accessToken)) {
      const accessToken = parseJwt(localStorage.getItem(AUTH_TOKEN_KEYS.accessToken));
      if (accessToken && accessToken['custom:accountid']) {
        accId = accessToken['custom:accountid'];
      }
    }
    const body = {
      accountId: accId,
      response: (_response$request$res = response === null || response === void 0 || (_response$request = response.request) === null || _response$request === void 0 ? void 0 : _response$request.response) !== null && _response$request$res !== void 0 ? _response$request$res : null,
      responseText: (_response$request$res2 = response === null || response === void 0 || (_response$request2 = response.request) === null || _response$request2 === void 0 ? void 0 : _response$request2.responseText) !== null && _response$request$res2 !== void 0 ? _response$request$res2 : null,
      responseUrl: (_response$request$res3 = response === null || response === void 0 || (_response$request3 = response.request) === null || _response$request3 === void 0 ? void 0 : _response$request3.responseUrl) !== null && _response$request$res3 !== void 0 ? _response$request$res3 : null,
      statusCode: (_response$status2 = response === null || response === void 0 ? void 0 : response.status) !== null && _response$status2 !== void 0 ? _response$status2 : null,
      correlationId: (_response$headers$cor = response === null || response === void 0 ? void 0 : response.headers['correlation-id']) !== null && _response$headers$cor !== void 0 ? _response$headers$cor : null,
      consoleErrorMessage: (_response$data$Error$2 = (_response$data11 = response.data) === null || _response$data11 === void 0 || (_response$data11 = _response$data11.Error) === null || _response$data11 === void 0 ? void 0 : _response$data11.GeneralErrorMessage) !== null && _response$data$Error$2 !== void 0 ? _response$data$Error$2 : null,
      timestamp: new Date(),
      windowUrl: window.location.href,
      applicationName: 'PM'
    };
    const xhr = new XMLHttpRequest();
    xhr.open('POST', "".concat(process.env.ACTIVITY_API_ENDPOINT, "/Monitoring/client-error"), true);
    xhr.setRequestHeader('Content-type', 'application/json');
    xhr.addEventListener('load', () => {
      // let data = resp.currentTarget.response;
      // data = JSON.parse(data);
    });
    xhr.send(JSON.stringify(body));
  },
  clearReqUnicIds() {
    store.inProgressUnicIds = null;
  },
  throwError(value) {
    store.throwable = value;
  }
}));
export function createAsync(thunk) {
  let auto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  let throwError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : auto;
  const thunkModel = asyncModel.named('thunkModel').actions(store => {
    let cancelTokenSource;
    return {
      async auto(promise) {
        try {
          store.start();
          const result = await promise();
          store.success();
          store.clearReqUnicIds();
          return result;
        } catch (error) {
          if (!isHttpClientCancel(error)) {
            store.failed(error, throwError);
          }
          store.clearReqUnicIds();
        }
        return undefined;
      },
      run(args, unicIds) {
        const thunkFn = thunk(args);
        store.inProgressUnicIds = unicIds;
        if (cancelTokenSource) {
          cancelTokenSource.cancel('CANCEL_REQUEST');
        }
        cancelTokenSource = httpClientCancelTokenStatic.source();
        let promise;
        if (Array.isArray(thunkFn)) {
          const _thunkFn = _slicedToArray(thunkFn, 1),
            actualThunk = _thunkFn[0];
          promise = () => actualThunk.bind(getParent(store))({
            cancelToken: {
              cancelToken: cancelTokenSource.token
            }
          }, store);
        } else {
          promise = () => thunkFn.bind(getParent(store))({
            cancelToken: {
              cancelToken: cancelTokenSource.token
            }
          }, store);
        }
        if (auto) {
          return this.auto(promise);
        }
        return promise();
      }
    };
  });
  return types.optional(thunkModel, {});
}